import script from "./SubgroupSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./SubgroupSelect.vue?vue&type=script&setup=true&lang=js"

import "./SubgroupSelect.vue?vue&type=style&index=0&id=28b0ced1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b0ced1"]])

export default __exports__